import { BrowserAuthOptions, PopupRequest } from "@azure/msal-browser";
import { AdaptClientConfiguration } from "@common/configuration/adapt-client-configuration";

export const OAuthSettings: BrowserAuthOptions = {
    clientId: AdaptClientConfiguration.MicrosoftClientId,
    authority: "https://login.microsoftonline.com/organizations/",
    redirectUri: `${window.location.origin}/redirect.html`,
};

export const microsoftLoginRequest: PopupRequest = {
    scopes: [
        "offline_access",
        "openid",
        "profile",
        "email",
        "user.read",
        "calendars.read",
        "calendars.readwrite.shared",
        "place.read.all",
    ],
};
